import React from "react";
import { CTAButton } from "./CTAButton";
import { libraryItems } from "../data/landing";
export function Library() {
  return <section className="bg-white px-5 py-16 text-navy-900 sm:py-20" data-id="element-188" data-mp="2idi43mjwkpn3">
      <div className="mx-auto max-w-5xl" data-id="element-189" data-mp="23nsnqk38of28">
        <div className="mx-auto max-w-2xl text-center" data-id="element-190" data-mp="23ouahltmapzs">
          <h2 className="font-display text-3xl font-black leading-tight sm:text-4xl" data-id="element-191" data-mp="28lceukl1cmbl">Your Complete Reference Library Also Includes</h2>
          <p className="mt-4 text-base leading-relaxed text-navy-700" data-id="element-192" data-mp="2wc84pc5xl7g7">
            With Denture Blueprint™, you receive more than six digital volumes. You'll also have practical resources designed to make the information easier to consult and organize.
          </p>
        </div>
        <ul className="mt-10 grid gap-x-8 gap-y-7 sm:grid-cols-2 lg:grid-cols-3" data-id="element-193" data-mp="2rbakku1d23c2">
          {libraryItems.map(({
          icon: Icon,
          title,
          text
        }) => <li key={title} className="flex gap-4" data-id="element-194" data-mp="1by7n87oowqho">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-navy-900 text-gold-400" data-id="element-195" data-mp="1fy8562azzjth">
                <Icon className="h-6 w-6" aria-hidden="true" data-id="element-196" data-mp="3lpb3dzza0069" />
              </span>
              <div data-id="element-197" data-mp="3grj0yc108vnt">
                <h3 className="text-lg font-bold" data-id="element-198" data-mp="3gs2ktya7tu4h">{title}</h3>
                <p className="mt-1 text-[15px] leading-relaxed text-navy-700" data-id="element-199" data-mp="3uqsef3xttbo3">{text}</p>
              </div>
            </li>)}
        </ul>
        <p className="mx-auto mt-10 max-w-2xl text-center text-base leading-relaxed text-navy-700" data-id="element-200" data-mp="3qqiadwtlgvbv">
          Whatever complete denture topic you're reviewing, Denture Blueprint™ gives you an organized collection of reference materials to consult alongside your professional knowledge and clinical judgment.
        </p>
        <div className="mt-8" data-id="element-201" data-mp="d9ho1ogokuqs">
          <CTAButton label="Get the Six-Volume Collection" data-id="element-202" data-mp="daao66l4wlzy" />
        </div>
      </div>
    </section>;
}